import React from "react";
import { useRoutes } from "react-router-dom";
import Register from "../auth/Register";
import CartPage from "../Cart/CartPage";
import HomeScreen from "../HomeScreen";
import Products from "../Products/Products";
import SinglePage from "../Singlepage/SinglePage";
import UploadPage from "../../Admin/Uploads/UploadProduct";
// import PrivateRouter from "./HiddenRoutes";
import ViewCats from "../Categories/ViewCats";

const AllRoutes = () => {
  let routes = useRoutes([
    {
      path: "/",
      element: <HomeScreen />,
    },
    {
      path: "/details/:id",
      element: <SinglePage />,
    },
    {
      path: "/categories/:id",
      element: <ViewCats />,
    },
    {
      path: "/cart",
      element: (
        //   <PrivateRouter>
        //   <CartPage />
        // </PrivateRouter>
        <CartPage />
      ),
    },
    {
      path: "/product",

      element: (
        // <PrivateRouter>
        //   <Products />,
        // </PrivateRouter>
        <Products />
      ),
    },
    {
      path: "/register",
      element: <Register />,
    },
    {
      path: "/admin/upload",
      element: (
        // <PrivateRouter>
        //   <UploadPage />
        // </PrivateRouter>
        <UploadPage />
      ),
    },
  ]);
  return <div>{routes}</div>;
};

export default AllRoutes;
